module.exports = __webpack_public_path__ + "static/media/iclauncher.11f612df.png";